import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import '../Assets/css/footerListdoc.scss';
import '../Assets/css/footerListresponsivedoc.scss';
import { connect } from 'react-redux';
import { loaderStateTrue, loaderStateFalse } from '../../../Actions/AllAction';
import { withNamespaces } from 'react-i18next';
import { withRouter, useHistory } from 'react-router-dom';
import BreadcrumbMenu from '../../../Utility/Components/BreadcrumbMenu';

function Faq(props) {


    const history = useHistory();

useEffect(() => {
    window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
    });
}, []);

    const homeMenuClick = () => {
        history.push(`/${localStorage.getItem('i18nextLng')}/home`);
    }



    return (

        <div className="aboutUsPage">
            <div className='footerBoxCover'>
                <div className='container'>
                    <div className="filterBox filterBoxMBottom">
                        <div className="leftSectionFilter">
                            <h2 className="pageTitle">Frequently Asked Questions</h2>
                        </div>
                    </div>
                </div>
            </div>
            <div className='container'>
                <BreadcrumbMenu
                    homeMenuDisplay={true}
                    faq_Display={true}
                    homeMenuClick={homeMenuClick}
                    active_faq={true}
                />

                <div className='aboutPageDetails paddingPageDetails'>
                    <div className='row'>
                    <div className='col-sm-6'>
                            <div className="card">
                            <h5 className="card-header">What makes a property a "The Staying" destination?</h5>
                                 <div className="card-body">
                                    <p className="card-text">Every property on our platform is carefully selected based on its unique character, local history,
and design. Instead of a basic room, we provide carefully chosen spaces that offer travellers a
meaningful cultural experience.</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-sm-6'>
                            <div className="card">
                            <h5 className="card-header">How do I find a stay tailored to a specific theme or experience?</h5>
                                 <div className="card-body">
                                    <p className="card-text">Do not search only by location. Use our website menu to browse properties by their style and
atmosphere. You can select Unique Theme to find distinct architectures, Curated Experience for
local activities, Signature Tours for guided group trips, or Exclusive Collaboration for special
partnership stays.</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-sm-6'>
                            <div className="card">
                            <h5 className="card-header">Can I reserve multiple rooms for a group getaway or a Signature Tour?</h5>
                                 <div className="card-body">
                                    <p className="card-text">Yes. You can select and book multiple rooms or units directly during the checkout process. For
corporate bookings, family events, or large group itineraries, please contact our team via
WhatsApp (+91 3345351510) for dedicated assistance. Mention that for larger groups, festival
trails (like your Shantipur Janmashtami Special or Boi Para Book Trail), or curated celebrations,
they can coordinate custom layouts via your direct channels.</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-sm-6'>
                            <div className="card">
                            <h5 className="card-header">How do I know my reservation is confirmed?</h5>
                                 <div className="card-body">
                                    <p className="card-text">You will receive an automated confirmation email immediately after your payment is processed.
This email includes your booking summary, receipt, and check-in instructions. We will also send
these updates to you via WhatsApp for easy communication.</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-sm-6'>
                            <div className="card">
                            <h5 className="card-header">How do I secure a curated stay or make a reservation with TheStaying?</h5>
                                 <div className="card-body">
                                    <p className="card-text">Select your preferred property or tour, choose your travel dates, and input your guest
information. You can then complete your booking securely through our online payment gateway
to finalise your reservation.</p>
                                </div>
                            </div>
                        </div>
                                                <div className='col-sm-6'>
                            <div className="card">
                            <h5 className="card-header">Can I cancel or modify an upcoming stay or custom journey?</h5>
                                 <div className="card-body">
                                    <p className="card-text">You can request changes or cancellations through your user dashboard or by contacting customer
support. Please note that individual properties maintain specific cancellation timelines, and
Signature Tours has distinct policy rules due to pre-arranged group arrangements. (embed the
policy link here.)</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )

}





const mapStateToProps = (globalState) => {
    return {
    };
}


export default connect(mapStateToProps, { loaderStateTrue, loaderStateFalse })
    (withNamespaces()(Faq));